import React,{useEffect,useState} from 'react'
import {Box,Typography} from '@mui/material';
import css from '../css/sidebarlink.module.css';
import {Link} from 'react-router-dom';
import {GrSettingsOption as Settings1,GrUserSettings as Settings2} from 'react-icons/gr';
import {FcInvite as InductionIcon} from  'react-icons/fc';
import { useLocation } from 'react-router-dom';
import {MdOutlinePortrait as ApplicantIcon1} from 'react-icons/md';
import {MdPortrait as ApplicationIcon2} from 'react-icons/md';
import {AiTwotoneMail as TrainingIcon, AiOutlineMail as TrainingIcon2} from 'react-icons/ai';
import {MdApproval as ApprovalIcon2} from 'react-icons/md';
import {MdOutlinePayment as PaymentIcon} from 'react-icons/md';
import { RiQuestionAnswerFill as InterviewIcon1,RiQuestionAnswerLine as InterviewIcon2 } from "react-icons/ri";
import {AiOutlineHome as Home1,AiTwotoneHome as Home2}  from 'react-icons/ai';
import { TbMessageReport as ReportIcon } from "react-icons/tb";
import { useSelector } from 'react-redux';




const linkList = [
    {icon1: <Home1 />, icon2: <Home2/>, path:"/dashboard/overview", name:"Overview", color:"#2E7D32"},
    {icon1: <Settings1/>, icon2: <Settings2/>, path:"/dashboard/settings", name:"Settings", color:"#7B1FA2"},
    {icon1: <ApplicantIcon1/>, icon2: <ApplicantIcon1/>, path:"/dashboard/applicants", name:"Applicants", color:"#1565C0"},
    {icon1: <ApplicationIcon2/>, icon2: <ApplicationIcon2/>, path:"/dashboard/old-applicants", name:"Old-Applicants", color:"#6D4C41"},
    {icon1: <ApplicantIcon1/>, icon2: <ApplicantIcon1/>, path:"/dashboard/applications", name:"Applications", color:"#00838F"},
    {icon1: <ApprovalIcon2/>, icon2: <ApprovalIcon2/>, path:"/dashboard/approvals", name:"Approvals", color:"#EF6C00"},
    {icon1: <PaymentIcon/>, icon2: <PaymentIcon/>, path:"/dashboard/payment", name:"Payment", color:"#C2185B"},
    // {icon1: <UploadIcon/>, icon2: <UploadIcon/>, path:"/dashboard/upload-off-line-payment", name:"Upload-OffLine-Payment"},
    {icon1: <InterviewIcon1/>, icon2: <InterviewIcon2/>, path:"/dashboard/interview", name:"Interview", color:"#303F9F"},
    {icon1: <TrainingIcon/>, icon2: <TrainingIcon2/>, path:"/dashboard/training-invites", name:"Training-Invites", color:"#F9A825"},
    {icon1: <InductionIcon/>, icon2: <InductionIcon/>, path:"/dashboard/induction-invites", name:"Induction-Invites", color:"#C62828"},
    {icon1: <ReportIcon/>, icon2: <ReportIcon/>, path:"/dashboard/reports", name:"Reports", color:"#37474F"},

];

const SideBarLinks = () => {
    const user = useSelector((store:any) => store.user);
    const displayName = user?.FirstName?.length > 10 ? `${user.FirstName.slice(0,10)}...` : user?.FirstName;

  return (
    <Box component={"div"} className={css.container}>
        <div className={css.welcome}>
            <span className={css.welcomeLabel}>Welcome!</span>
            <span className={css.welcomeName}>{displayName}</span>
        </div>
        <Typography component={"div"} style={{ marginBlock: '4px'}}>
            {linkList.map((eLink,index) =>
                <EachLink key={index} eLink={eLink} index={index}/>)
            }
        </Typography>
    </Box>
  )
}

export default SideBarLinks;

const EachLink = (props: any) => {
  const eLink = props.eLink;
  const index = props.index;
  const [activeIcon, setActiveIcon] = useState(eLink.icon1);
  const [activeClass, setActiveClass] = useState('');
  const location = useLocation();
  const user = useSelector((store: any) => store.user);

  useEffect(() => {
    const activePath = location.pathname;

    if (eLink.path && activePath === eLink.path) {
      setActiveIcon(eLink.icon2);
      setActiveClass(css.activeLink);
    } else if (
      activePath.includes("old-applicants") &&
      eLink.name.toLowerCase() === "applicants"
    ) {
      setActiveClass('');
      setActiveIcon(eLink.icon1);
    } else {
      setActiveIcon(eLink.icon1);
      setActiveClass('');
    }
  }, [location.pathname, eLink.path]);

  return (
    <>
      {/* ✅ Pass roles (array) not role (null string) */}
      <AuthorizeView
        roles={user?.RoleNames ?? []}
        name={eLink.name}
        link={
          <Link to={eLink.path} className={activeClass}>
            <span style={{ color: eLink.color, fontSize: '18px' }}>
              {activeIcon}
            </span>
            <span style={{ fontSize: '14px' }}>{eLink.name}</span>
          </Link>
        }
      />
    </>
  );
};

export const AuthorizeView = (props: any) => {
  const name: string = props.name.toLowerCase();
  const link = props.link;
  const userRoles: string[] = props.roles ?? [];
  const allowedRoles = ["Administrator"];
  const isSettingsLink = name.includes("settings");

  if (isSettingsLink) {
    const hasAccess = userRoles.some(role => allowedRoles.includes(role));
    return hasAccess ? link : <></>;
  }

  return link;
};